/* SnugMile theme - minimal, dependency-free. Nothing here is required for
   checkout to work: the product form is a native Shopify form and the cart
   page uses native form posts. JS only enhances. */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Countdown (announcement bar) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var hours = parseInt(el.getAttribute('data-countdown'), 10) || 12;
    var key = 'sm_cd_' + hours;
    var end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { end = null; }
    if (!end || isNaN(end) || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(key, String(end)); } catch (e) {}
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var parts = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      var nodes = el.querySelectorAll('b');
      for (var i = 0; i < nodes.length && i < parts.length; i++) nodes[i].textContent = pad(parts[i]);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || !input) return;
      e.preventDefault();
      var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var val = (parseInt(input.value, 10) || min) + step;
      input.value = Math.max(min, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelector('[data-gallery-slides]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    if (!slides) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-gallery-thumb'), 10) || 0;
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', parseInt(t.getAttribute('data-gallery-thumb'), 10) === i ? 'true' : 'false');
      });
    }, { passive: true });
  });

  /* ---------- Variant picker ----------
     Reads the variant list rendered by Liquid, keeps the hidden id input in
     sync with the selected options, and updates price / availability.
     If anything here fails, the <noscript> fallback select still submits a
     valid variant id, so the product can always be bought. */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceNow = form.querySelector('[data-price-now]');
    var priceWas = form.querySelector('[data-price-was]');
    var badge = form.querySelector('[data-price-badge]');
    var submit = form.querySelector('[data-add-button]');
    var barPrice = document.querySelector('[data-bar-price]');
    var moneyEl = form.querySelector('[data-money-format]');
    var money = (moneyEl && moneyEl.getAttribute('data-money-format')) || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
                  .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0]);
    }

    function selected() {
      var arr = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var i = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        arr[i] = checked ? checked.value : null;
      });
      for (var k = 0; k < arr.length; k++) { if (arr[k] === undefined) arr[k] = null; }
      return arr;
    }

    function match(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function update() {
      var opts = selected();

      /* grey out combinations that do not exist */
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var found = variants.find(function (v) {
            return test.every(function (o, i) { return o === null || v.options[i] === o; });
          });
          input.disabled = !found;
        });
      });

      /* pack card prices follow the other selected options */
      form.querySelectorAll('[data-option-pack]').forEach(function (group) {
        var gidx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-pack-price]').forEach(function (node) {
          var test = opts.slice();
          test[gidx] = node.getAttribute('data-pack-value');
          var pv = variants.find(function (vv) {
            return test.every(function (o, i) { return o === null || vv.options[i] === o; });
          });
          if (!pv) return;
          var html = '<b>' + formatMoney(pv.price) + '</b>';
          if (pv.compare_at_price && pv.compare_at_price > pv.price) {
            html += '<s>' + formatMoney(pv.compare_at_price) + '</s>';
          }
          node.innerHTML = html;
        });
      });

      /* "Color: Blue" style labels */
      form.querySelectorAll('[data-option-selected]').forEach(function (el) {
        var li = parseInt(el.getAttribute('data-option-selected'), 10);
        if (opts[li]) el.textContent = opts[li];
      });

      var variant = match(opts);
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = submit.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id; if (variant.featured_image && variant.featured_image.src) { var vkey = variant.featured_image.src.split('?')[0].split('/').pop().split('.')[0]; var gal = document.querySelector('[data-gallery-slides]'); if (gal) { var gimgs = gal.querySelectorAll('img'); for (var gi = 0; gi < gimgs.length; gi++) { if (gimgs[gi].getAttribute('src').split('?')[0].split('/').pop().indexOf(vkey) === 0) { gal.scrollTo({ left: gal.clientWidth * gi, behavior: 'smooth' }); break; } } } }

      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.hidden = false;
          if (badge) {
            badge.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
            badge.hidden = false;
          }
        } else {
          priceWas.hidden = true;
          if (badge) badge.hidden = true;
        }
      }
      if (barPrice) barPrice.textContent = formatMoney(variant.price);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? (submit.getAttribute('data-add') || 'Add to cart')
          : (submit.getAttribute('data-soldout') || 'Sold out');
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]')) update();
    });
    update();
  });

  /* ---------- Sticky buy bar ---------- */
  var bar = document.querySelector('[data-buybar]');
  var anchor = document.querySelector('[data-buybar-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -10% 0px' }).observe(anchor);
    var barBtn = bar.querySelector('[data-buybar-button]');
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        var realForm = document.querySelector('[data-product-form]');
        if (realForm) realForm.requestSubmit ? realForm.requestSubmit() : realForm.submit();
      });
    }
  }
})();
